import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthenticationProvider } from '../../../my-dashboard/context/AuthenticationContext';
import AuthenticationBar from './AuthenticationBar';

const $authenticationBars: NodeListOf<HTMLElement> | null = document.querySelectorAll('.timken-authentication-bar');

if ($authenticationBars) {
	$authenticationBars.forEach(($bar) => {
		const isDetailsPage = $bar.dataset.details ? !! parseInt($bar.dataset.details) : false;
		const isBearing = $bar.dataset.bearing ? !! parseInt($bar.dataset.bearing) : false;
		const isSearchPage = $bar.dataset.search ? !! parseInt($bar.dataset.search) : false;
		const $root = ReactDOM.createRoot($bar as HTMLElement);

		$root.render(
			<React.StrictMode>
				<AuthenticationProvider>
					<AuthenticationBar
						isDetailsPage={isDetailsPage}
						customClassName={isDetailsPage ? 'authentication-bar-details-page' : isSearchPage ? 'authentication-bar-custom-search' : ''}
						isBearing={isBearing}
					/>
				</AuthenticationProvider>
			</React.StrictMode>,
		);
	});
}
